import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer, mergeAttributes } from "@tiptap/react";

import { Renderer } from "./Renderer";

export const FileExtension = Node.create({
  name: "file",
  group: "block",
  atom: true,
  addAttributes: () => ({
    signed_id: {
      default: null,
    },
  }),
  parseHTML: () => [{ tag: "file-react" }],
  renderHTML: ({ HTMLAttributes }) => [
    "file-react",
    mergeAttributes(HTMLAttributes),
  ],
  addNodeView: () => props => {
    const nodeView = ReactNodeViewRenderer(Renderer)(props);
    let isNodeSelected = false;
    const originalStopEvent = nodeView.stopEvent?.bind(nodeView);
    const originalSelectNode = nodeView.selectNode?.bind(nodeView);
    const originalDeselectNode = nodeView.deselectNode?.bind(nodeView);

    nodeView.selectNode = () => {
      isNodeSelected = true;
      originalSelectNode?.();
    };

    nodeView.deselectNode = () => {
      isNodeSelected = false;
      originalDeselectNode?.();
    };

    // Fixes issues changing video playback position in Firefox and Safari
    nodeView.stopEvent = event => {
      if (isNodeSelected && event.type === "mousedown") {
        return true;
      }
      return originalStopEvent(event);
    };

    return nodeView;
  },
});
